<!-- 
  首页右边板块
 -->
<template>
  <div class="you_section">
    <BottomBack :borderStyle="{ transform: 'scaleX(1)', left: 0 }">
      <div class="main">
        <TodayData />
        <!-- <DevStat /> -->
        <OzoneMonitor />
        <WarningInfo />
      </div>
    </BottomBack>
  </div>
</template>

<script>
import BottomBack from "../BottomBack";
// 今日污水处理、设备统计、报警信息组件
import TodayData from "./components/TodayData";
import DevStat from "./components/DevStat";
import OzoneMonitor from "./components/OzoneMonitor.vue";
import WarningInfo from "./components/WarningInfo";

import { areaListApi, deviceTypeListApi } from "@/api/basic";
export default {
  name: "rigthSection",
  components: {
    BottomBack,
    TodayData,
    DevStat,
    OzoneMonitor,
    WarningInfo,
  },
  data() {
    return {};
  },

  mounted() {
    areaListApi().then((res) => {
      console.log(res);
    });
    // deviceTypeListApi().then(res => {
    //   console.log(res)
    // })
  },
};
</script>

<style lang="less" scoped>
.you_section {
  position: fixed;
  top: 325vh * @vh;
  right: 0;

  .main {
    position: absolute;
    left: 15px;
    top: 117vh * @vh;
  }
}
@media screen and (min-width: 3640px), screen and(max-height: 1080) {
  .you_section {
    top: 225vh * @vh;
    .main {
      left: 200px;
    }
  }
}
</style>